module.exports = __webpack_public_path__ + "static/media/ARSHAD-ANSARI.5c5ac41a.png";